export default __webpack_public_path__ + "static/media/top-bg2.7cb5c56d.png";